<template>
  <div class="flex flex-col gap-4">
    <TranscriptionUpsellingInline v-if="showAiAddonUpsellingInline" :is-new-plan="isNewPlanWithoutAi" @close="closeAIAddon" />
    <TranscriptionEmpty v-if="!canHaveTranscription" />
    <template v-else-if="isTranscriptionGenerated && !isEditProcessing && (!isCurrentItemOwner || !isNewPlanWithoutAi)">
      <template v-if="isTranscriptionFinished">
        <TranscriptionEmpty v-if="isTranscriptionEmpty" />
        <TranscriptionWrapper v-else />
      </template>
      <TranscriptionProcessing v-else-if="isTranscriptionProcessing" />
      <TranscriptionRetry v-else-if="isTranscriptionFailed" />
    </template>

    <TranscriptionVideoProcessing v-else-if="isEditProcessing" />
    <TranscriptionRequest v-else-if="hasAiAddon && isCurrentItemOwner" />
    <TranscriptionUpselling v-else-if="isCurrentItemOwner" :is-new-plan="isNewPlanWithoutAi" />
  </div>
</template>

<script lang="ts" setup>
import { useTranscriptionStore } from '@/modules/viewer/store/useTranscriptionStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { storeToRefs } from 'pinia';
import { computed, onBeforeMount, ref } from 'vue';

import TranscriptionRequest from './TranscriptionRequest.vue';
import TranscriptionEmpty from './TranscriptionEmpty.vue';
import TranscriptionUpselling from './TranscriptionUpselling.vue';
import TranscriptionWrapper from './general/TranscriptionWrapper.vue';
import TranscriptionRetry from './TranscriptionRetry.vue';
import TranscriptionProcessing from './TranscriptionProcessing.vue';
import TranscriptionVideoProcessing from './TranscriptionVideoProcessing.vue';
import TranscriptionUpsellingInline from './TranscriptionUpsellingInline.vue';

import { useAddon } from '@/modules/viewer/composables/useAddon';
import { useEntitlements } from '@/composables/useEntitlements';
import { useUser } from '@/modules/viewer/composables/useUser';

const transcriptionStore = useTranscriptionStore();
const store = useViewerItemStore();

const { isCurrentItemOwner } = useUser();
const { can } = useEntitlements();
const { hasAiAddon, isNewPlanWithoutAi } = useAddon();

const { isEditProcessing, canHaveTranscription } = storeToRefs(store);
const { isTranscriptionEmpty, isTranscriptionGenerated, isTranscriptionFinished, isTranscriptionFailed, isTranscriptionProcessing } =
  storeToRefs(transcriptionStore);

const isTranscriptionEnabled = can('viewerTranscription');

const showAiAddon = ref(true);

const closeAIAddon = () => {
  showAiAddon.value = false;
};
const showAiAddonUpsellingInline = computed(() => {
  return isTranscriptionEnabled.value && isCurrentItemOwner.value && !hasAiAddon.value && showAiAddon.value;
});

onBeforeMount(() => transcriptionStore.loadTranscription(transcriptionStore.transcriptionId));
</script>
